// Charts -> Bar colors
//  colors.brand["600"],
//  colors.brand["200"],
//  colors.brand["800"],
//  colors.grey["400"],
//  colors.grey["500"],
//  colorScheme.default.borderHover,

import { constants } from "shared/constants";

// Charts -> Pie colors
// colorScheme.brand.backgroundFocus2,
// colorScheme.brand.foreground3,
// colorScheme.brand.background,
// colorScheme.default.borderHover,
// colorScheme.default.foreground2,
// colorScheme.default.foreground,

const mainBlue = "#5465ff";
const mainGreen = "#06D6A0";
const mainPink = "#9C2780";
const mainRed = "#9A031E";

const barBlueTheme = {
    siteVariables: {
        colorScheme: {
            default: {
                borderHover: "#C7C7C7",
            },
        },
        colors: {
            grey: {
                400: "#8A8A8A",
                500: "#424242",
            },
            brand: {
                200: mainBlue,
                600: "#CBCBCB",
                800: "#464775",
            },
        },
    },
};

const pieBlueTheme = {
    siteVariables: {
        colorScheme: {
            default: {
                borderHover: "#BFD7FF", // 4th color
                foreground2: "#D1EAFF", // 5th color
            },
            brand: {
                backgroundFocus2: mainBlue, // 1st color
                foreground3: "#788bff", // 2nd color
                background: "#9bb1ff", // 3rd color
            },
        },
    },
};

const barGreenTheme = {
    siteVariables: {
        colorScheme: {
            default: {
                borderHover: "#C7C7C7",
            },
        },
        colors: {
            grey: {
                400: "#8A8A8A",
                500: "#424242",
            },
            brand: {
                200: mainGreen,
                600: "#CBCBCB",
                800: "#464775",
            },
        },
    },
};

const pieGreenTheme = {
    siteVariables: {
        colorScheme: {
            default: {
                borderHover: "#B5E48C", // 4th color
                foreground2: "#D9ED92", // 5th color
            },
            brand: {
                backgroundFocus2: mainGreen, // 1st color
                foreground3: "#168AAD", // 2nd color
                background: "#99D98C", // 3rd color
            },
        },
    },
};

const barPinkTheme = {
    siteVariables: {
        colorScheme: {
            default: {
                borderHover: "#C7C7C7",
            },
        },
        colors: {
            grey: {
                400: "#8A8A8A",
                500: "#424242",
            },
            brand: {
                200: mainPink,
                600: "#CBCBCB",
                800: "#464775",
            },
        },
    },
};

const piePinkTheme = {
    siteVariables: {
        colorScheme: {
            default: {
                borderHover: "#22BA93", // 4th color
                foreground2: "#035A43", // 5th color
            },
            brand: {
                backgroundFocus2: mainPink, // 1st color
                foreground3: "#CBCBCB", // 2nd color
                background: "#464775", // 3rd color
            },
        },
    },
};

const barRedTheme = {
    siteVariables: {
        colorScheme: {
            default: {
                borderHover: "#C7C7C7",
            },
        },
        colors: {
            grey: {
                400: "#8A8A8A",
                500: "#424242",
            },
            brand: {
                200: mainRed,
                600: "#CBCBCB",
                800: "#464775",
            },
        },
    },
};

const pieRedTheme = {
    siteVariables: {
        colorScheme: {
            default: {
                borderHover: "#22BA93", // 4th color
                foreground2: "#035A43", // 5th color
            },
            brand: {
                backgroundFocus2: mainRed, // 1st color
                foreground3: "#BF3419", // 2nd color
                background: "#E36414", // 3rd color
            },
        },
    },
};

export const chartThemes = {
    bar: {
        blue: barBlueTheme,
        green: barGreenTheme,
        pink: barPinkTheme,
        red: barRedTheme,
    },
    pie: {
        blue: pieBlueTheme,
        green: pieGreenTheme,
        pink: piePinkTheme,
        red: pieRedTheme,
    },
};

export const getThemeForBarChart = (themeName: string | undefined) => {
    switch (themeName) {
        case constants.v360ReportThemeNames.blue:
            return barBlueTheme;
        case constants.v360ReportThemeNames.green:
            return barGreenTheme;
        case constants.v360ReportThemeNames.pink:
            return barPinkTheme;
        default:
            return barRedTheme;
    }
};

export const getThemeForPieChart = (themeName: string | undefined) => {
    switch (themeName) {
        case constants.v360ReportThemeNames.blue:
            return pieBlueTheme;
        case constants.v360ReportThemeNames.green:
            return pieGreenTheme;
        case constants.v360ReportThemeNames.pink:
            return piePinkTheme;
        default:
            return pieRedTheme;
    }
};

export const getThemeMainColor = (themeName: string | undefined) => {
    switch (themeName) {
        case constants.v360ReportThemeNames.blue:
            return mainBlue;
        case constants.v360ReportThemeNames.green:
            return mainGreen;
        case constants.v360ReportThemeNames.pink:
            return mainPink;
        default:
            return mainRed;
    }
};
